import type { ExternalServiceConfig as ExternalService } from "api/schemas";

import RingBackdrop from "../../RingBackdrop/RingBackdrop";
import { useOptionalExternalServicesState } from "../context";

import styles from "./hyly.module.css";

export interface ScheduleVisitCardProps {
  externalServices: ExternalService[];
}

const ScheduleVisitCard = ({ externalServices }: ScheduleVisitCardProps) => {
  const externalServicesState = useOptionalExternalServicesState();

  const hylyService = externalServices.find(
    (service) => service.type === "Hyly"
  );

  const handleClick = () => {
    externalServicesState?.onScheduleTourUrlClick?.();
  };

  if (!hylyService) {
    return null;
  }

  return (
    <div className={styles.card}>
      <div style={{ position: "absolute", overflow: "hidden", inset: 0 }}>
        <RingBackdrop />
      </div>

      <h3 className={styles.title}>Visit and Tour Your Favorites</h3>
      <p className={styles.subtitle}>
        Take the next step and get a personalized tour. Your request will be
        reviewed and confirmed via email.
      </p>

      <div style={{ marginTop: "20px" }}>
        <a
          href={hylyService.additional_data?.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Schedule a visit (opens in a new tab)"
          onClick={handleClick}
        >
          <button className={styles.button}>Schedule Visit</button>
        </a>
      </div>
    </div>
  );
};

export default ScheduleVisitCard;
